const AIR_N2_FRACTION = 0.79

export function blendLitres ({ o2Pct, hePct, cylinderSize, fillPressure }) {
  if (!Number.isFinite(o2Pct) || !Number.isFinite(hePct)) return null
  if (!Number.isFinite(cylinderSize) || !Number.isFinite(fillPressure)) return null
  if (cylinderSize <= 0 || fillPressure <= 0) return null
  if (o2Pct < 21 || o2Pct > 100) return null
  if (hePct < 0 || hePct > 100) return null
  if (o2Pct + hePct > 100) return null

  const fO2 = o2Pct / 100
  const fHe = hePct / 100
  const fN2 = 1 - fO2 - fHe
  const totalGas = cylinderSize * fillPressure

  const air = totalGas * fN2 / AIR_N2_FRACTION
  const he = totalGas * fHe
  const o2 = totalGas - air - he

  if (o2 < -1e-6) return null

  return {
    air: Math.max(0, air),
    o2: Math.max(0, o2),
    he: Math.max(0, he)
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/stations/station/Pricing/blendLitres.js